import { Modal, Form, Button, Select, List, Avatar, Badge, Space, Tag, Typography, App, InputNumber } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { Localization, _T } from '../../../../../base-react/src/Localization';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var FederationSource = models.federations.FederationSource;
var ClassRoundSource = models.rounds.ClassRoundSource;
var DivisionSource = models.federations.DivisionSource;
var DisciplineSource = models.federations.DisciplineSource;
var FederationClassSource = models.federations.FederationClassSource;
var ClassRuleSource = models.federations.ClassRuleSource;
var DanceSource = models.federations.DanceSource;
var JudgingSource = models.judging.JudgingSource;
var ScheduleSource = models.schedules.ScheduleSource;
var FloorSource = models.floors.FloorSource;
import { PlusOutlined } from '@ant-design/icons';
import { useCompetition } from '../../../../../base-react/hooks/Competition';
import { RoundGenerator } from '../../../../../base-react/src/RoundGenerator';
import { flattenTree } from '../../../event/schedule/utilities';
import { useSchedulePages } from '../../../../../base-react/hooks/Schedule';
const { Text } = Typography;
export const ClassRoundGuide = (props) => {
    const { competition_id, classItem, rounds, disabled } = props;
    const { notification } = App.useApp();
    const [inputCompetition, event, competitions, loadingCompetition] = useCompetition(competition_id);
    const [federations, loadingFederations] = Stream(FederationSource);
    const [judging] = Stream(inputCompetition && JudgingSource(inputCompetition.federation_id));
    const [schedule, loadingSchedule] = Stream(event && ScheduleSource(event.competition_id));
    const [floors, loadingFloors] = Stream(event && FloorSource(event.competition_id));
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [previewRounds, setPreviewRounds] = useState([]);
    const [filteredClasses, setFilteredClasses] = useState([]);
    const [tags, setTags] = useState([]);
    const { pages, pageData } = useSchedulePages(event === null || event === void 0 ? void 0 : event.competition_id, schedule);
    const watchedFederationId = Form.useWatch('federation_id', form);
    const watchedDivisionId = Form.useWatch('division_id', form);
    const watchedDisciplineId = Form.useWatch('discipline_id', form);
    const watchedFederationClassId = Form.useWatch('federation_class_id', form);
    const schedule_id = Form.useWatch('schedule_id', form);
    const floor_id = Form.useWatch('floor_id', form);
    const federation_id = watchedFederationId !== null && watchedFederationId !== void 0 ? watchedFederationId : event === null || event === void 0 ? void 0 : event.federation_id;
    const division_id = watchedDivisionId !== null && watchedDivisionId !== void 0 ? watchedDivisionId : classItem === null || classItem === void 0 ? void 0 : classItem.division_id;
    const discipline_id = watchedDisciplineId !== null && watchedDisciplineId !== void 0 ? watchedDisciplineId : classItem === null || classItem === void 0 ? void 0 : classItem.discipline_id;
    const federation_class_id = watchedFederationClassId !== null && watchedFederationClassId !== void 0 ? watchedFederationClassId : classItem === null || classItem === void 0 ? void 0 : classItem.federation_class_id;
    const [divisions, loadingDivisions] = Stream(DivisionSource(federation_id));
    const [disciplines, loadingDisciplines] = Stream(DisciplineSource(federation_id, division_id));
    const [federationClasses, loadingFederationClasses] = Stream(FederationClassSource(federation_id));
    const [classRules, loadingClassRules] = Stream(ClassRuleSource(federation_id, division_id, discipline_id));
    const [dances] = Stream(DanceSource(federation_id, division_id, discipline_id));
    const applyScheduleIdToRoundTree = (roundItems, importScheduleId) => {
        if (!Array.isArray(roundItems) || !importScheduleId) {
            return roundItems;
        }
        return roundItems.map((round) => ({
            ...round,
            schedule_id: importScheduleId,
            children: Array.isArray(round === null || round === void 0 ? void 0 : round.children)
                ? applyScheduleIdToRoundTree(round.children, importScheduleId)
                : round === null || round === void 0 ? void 0 : round.children
        }));
    };
    const defaultScheduleId = useMemo(() => {
        var _a, _b;
        if (!schedule || schedule.length === 0) {
            return undefined;
        }
        const competitionStartDate = event === null || event === void 0 ? void 0 : event.competition_date;
        const dayOneBreak = competitionStartDate
            ? schedule.find((item) => item.schedule_type === 'break' && item.schedule_date === competitionStartDate)
            : undefined;
        if (dayOneBreak === null || dayOneBreak === void 0 ? void 0 : dayOneBreak.schedule_id) {
            const startIndex = schedule.findIndex((item) => item.schedule_id === dayOneBreak.schedule_id);
            if (startIndex >= 0) {
                const followingItems = schedule.slice(startIndex + 1);
                const nextBreakIndex = followingItems.findIndex((item) => item.schedule_type === 'break');
                const dayOneItems = (nextBreakIndex >= 0 ? followingItems.slice(0, nextBreakIndex) : followingItems)
                    .filter((item) => item.schedule_id && item.schedule_type !== 'break');
                return ((_a = dayOneItems[dayOneItems.length - 1]) === null || _a === void 0 ? void 0 : _a.schedule_id) || dayOneBreak.schedule_id;
            }
        }
        const firstPageItems = (pageData === null || pageData === void 0 ? void 0 : pageData[0]) || [];
        return (_b = firstPageItems[firstPageItems.length - 1]) === null || _b === void 0 ? void 0 : _b.schedule_id;
    }, [event === null || event === void 0 ? void 0 : event.competition_date, pageData, schedule]);
    const defaultFloorId = useMemo(() => {
        var _a;
        if (!floors || floors.length === 0) {
            return undefined;
        }
        return (_a = floors[0]) === null || _a === void 0 ? void 0 : _a.floor_id;
    }, [floors]);
    useEffect(() => {
        if (!visible) {
            return;
        }
        if (federationClasses) {
            const foundClass = federationClasses.find(a => { var _a; return [a.federation_class_legacy_code, a.federation_class_code].includes((_a = classItem.class_name) === null || _a === void 0 ? void 0 : _a.split('/')[0]); });
            if (foundClass) {
                form.setFieldsValue(foundClass);
            }
        }
    }, [visible, federationClasses]);
    useEffect(() => {
        setFilteredClasses(federationClasses ?
            federationClasses.filter(a => a.discipline_id === discipline_id)
                .sort((a, b) => ((a.federation_class_order != null ? a.federation_class_order : Number(a.federation_class_id))
                -
                    (b.federation_class_order != null ? b.federation_class_order : Number(b.federation_class_id)))) : []);
    }, [discipline_id, federationClasses]);
    useEffect(() => {
        let allTags = classRules ? classRules.map(rule => rule.class_rule_tags ? JSON.parse(rule.class_rule_tags) : []) : [];
        setTags(allTags === null || allTags === void 0 ? void 0 : allTags.flat());
    }, [classRules]);
    useEffect(() => {
        if (!visible || !defaultScheduleId || form.getFieldValue('schedule_id')) {
            return;
        }
        form.setFieldValue('schedule_id', defaultScheduleId);
    }, [defaultScheduleId, form, visible]);
    useEffect(() => {
        if (!visible || !defaultFloorId || form.getFieldValue('floor_id')) {
            return;
        }
        form.setFieldValue('floor_id', defaultFloorId);
    }, [defaultFloorId, form, visible]);
    const onFinish = (fieldsValue) => {
        if (rounds && rounds.some(a => a.round_count > 0)) {
            notification.error({
                title: _T('classrules.error.has-teams')
            });
            return;
        }
        setIsLoading(true);
        const roundsToImport = previewRounds.length > 0 ? previewRounds : generateRounds(fieldsValue['class_count'], fieldsValue['class_rule_tags']);
        Api.call(ClassRoundSource(classItem.class_id).url, 'import-rounds', {
            rounds: flattenTree(applyScheduleIdToRoundTree(roundsToImport, schedule_id)),
            schedule_id: schedule_id,
            floor_id: floor_id
        })
            .then(() => {
            setIsLoading(false);
            handleCancel();
        })
            .catch((err) => {
            setIsLoading(false);
            notification.error({
                title: err.response && err.response.message ? _T(err.response.message) : err.message
            });
        });
    };
    const handleCancel = () => {
        form.resetFields();
        setPreviewRounds([]);
        setVisible(false);
    };
    const handlePreview = () => {
        const values = form.getFieldsValue();
        const rounds = generateRounds(values['class_count'], values['class_rule_tags']);
        setPreviewRounds(rounds);
    };
    const generateRounds = (count, tags) => {
        const foundClass = federationClasses === null || federationClasses === void 0 ? void 0 : federationClasses.find(a => a.federation_class_id === federation_class_id);
        const roundGenerator = new RoundGenerator([foundClass], classRules, dances, judging);
        return roundGenerator.generateRounds(count, tags)[0].rounds;
    };
    const scheduleOptions = pages && pages.length > 1 ? pages.map((page, index) => ({
        label: page.schedule_value,
        value: page.schedule_id,
        options: pageData[index].map(data => ({
            label: data.schedule_value,
            value: data.schedule_id
        }))
    })) : pageData[0].map(data => ({
        label: data.schedule_value,
        value: data.schedule_id
    }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "primary", disabled: disabled, icon: React.createElement(PlusOutlined, null), onClick: () => setVisible(true) }, _T('guide.title')),
        React.createElement(Modal, { title: _T('guide.title'), open: visible, onCancel: handleCancel, footer: [
                React.createElement(Button, { key: "cancel", onClick: handleCancel }, _T('common.cancel.title')),
                React.createElement(Button, { key: "preview", type: "dashed", onClick: handlePreview, disabled: !federation_class_id }, _T('common.preview')),
                React.createElement(Button, { key: "submit", type: "primary", form: "class_item_guide_" + classItem.class_id, htmlType: 'submit', disabled: isLoading, loading: isLoading }, _T('common.create', { name: _T('round.plural').toLowerCase() }))
            ] },
            React.createElement(Form, { name: "class_item_guide_" + classItem.class_id, form: form, labelCol: { span: 8 }, wrapperCol: { span: 16 }, onFinish: onFinish, initialValues: {
                    federation_id: event && event.federation_id,
                    division_id: classItem && classItem.division_id,
                    discipline_id: classItem && classItem.discipline_id,
                    federation_class_id: classItem && classItem.federation_class_id,
                    class_label: classItem && classItem.class_label,
                    class_name: classItem && classItem.class_name,
                    class_count: classItem && classItem.class_count,
                    class_rule_tags: []
                } },
                React.createElement(Form.Item, { label: _T('competition.details.federation_id.label'), name: "federation_id", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, { loading: loadingFederations, placeholder: _T('competition.details.federation_id.label') }, federations && federations.map(item => (React.createElement(Select.Option, { value: item.federation_id, key: item.federation_id }, item.federation_name))))),
                React.createElement(Form.Item, { label: _T('class.details.division_id'), name: "division_id", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, { loading: loadingDivisions, placeholder: _T('class.details.division_id') }, divisions && divisions.map(item => (React.createElement(Select.Option, { value: item.division_id, key: item.division_id }, item.division_name))))),
                React.createElement(Form.Item, { label: _T('class.details.discipline_id'), name: "discipline_id", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, { loading: loadingDisciplines, placeholder: _T('class.details.discipline_id') }, disciplines && disciplines.map(item => (React.createElement(Select.Option, { value: item.discipline_id, key: item.discipline_id }, item.discipline_name))))),
                React.createElement(Form.Item, { label: _T('class.details.federation_class_id'), name: "federation_class_id", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, { loading: loadingFederationClasses, placeholder: _T('class.details.federation_class_id') }, filteredClasses && filteredClasses.map(item => (React.createElement(Select.Option, { value: item.federation_class_id, key: item.federation_class_id }, item.federation_class_name))))),
                React.createElement(Form.Item, { name: "class_rule_tags", label: _T('classrules.details.class_rule_tags.label'), rules: [{ type: 'array' }] },
                    React.createElement(Select, { loading: loadingClassRules, mode: 'multiple' }, tags && tags.map(item => React.createElement(Select.Option, { value: item, key: item }, item)))),
                React.createElement(Form.Item, { label: _T('round.details.schedule_id.label'), name: "schedule_id", rules: [{ required: true, message: _T('common.required') }] },
                    React.createElement(Select, { loading: loadingSchedule, placeholder: _T('round.details.schedule_id.label'), options: scheduleOptions })),
                React.createElement(Form.Item, { label: _T('round.details.floor_id.label'), name: "floor_id" },
                    React.createElement(Select, { loading: loadingFloors, placeholder: _T('round.details.floor_id.label') }, floors && floors.map(item => (React.createElement(Select.Option, { value: item.floor_id, key: item.floor_id }, item.floor_name || _T('common.empty')))))),
                React.createElement(Form.Item, { label: _T('classrules.participants'), name: "class_count" },
                    React.createElement(InputNumber, null))),
            previewRounds.length > 0 &&
                React.createElement(List, { dataSource: previewRounds, renderItem: (item, index) => {
                        var _a, _b, _c;
                        const effectiveHeatCount = (_c = (_b = (_a = item.children) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.round_num_heats) !== null && _c !== void 0 ? _c : item.round_num_heats;
                        return (React.createElement(List.Item, null,
                            React.createElement(List.Item.Meta, { avatar: React.createElement(Avatar, null, item.round_count), title: React.createElement(Space, null,
                                    item.round_label,
                                    " ",
                                    React.createElement(Text, { type: "secondary" }, item.judging_label && Localization.getLocalizedString(JSON.parse(item.judging_label)))), description: React.createElement(Space, { wrap: true },
                                    item.round_position &&
                                        `#${item.round_position}`,
                                    item.round_heat_length &&
                                        `${item.round_heat_length}s`,
                                    effectiveHeatCount &&
                                        _T('heat.count', { count: effectiveHeatCount }),
                                    item.children && item.children.map((dance, danceIndex) => (React.createElement(Tag, { key: danceIndex },
                                        dance.round_label,
                                        " ",
                                        dance.dance_round_type)))) }),
                            item.round_num_through > 0 && React.createElement(Badge, { count: item.round_num_through, overflowCount: 999 })));
                    } }))));
};
